import * as React from "react"
import {useTranslation} from "react-i18next";
import NavBar from "../../components/NavBar";
import {Link, useLocation, useSearchParams} from "react-router-dom";
import {handleSetQuery} from "../../assets/js/main";
import {Add} from "@mui/icons-material";


export default function AboutUS() {
  const {t} = useTranslation()
  const location = useLocation();


  return (
     <>
       <NavBar/>

       <div className="LoginEDUPage">
         <div className="container">
           <div className="row">
             <div className="col-12">
               <h2>{t("loginEDU.t1")}</h2>
               <p>{t("loginEDU.t2")}</p>

               <div className="item">
                 <h4>{t("loginEDU.t3")}</h4>
                 <p>{t("loginEDU.t4")}</p>
                 <img src={require('./../../assets/img/edu/1.png')} alt=""/>
               </div>
               <div className="item">
                 <h4>{t("loginEDU.t5")}</h4>
                 <img src={require('./../../assets/img/edu/2.png')} alt=""/>
               </div>
               <div className="item">
                 <h4>{t("loginEDU.t6")}</h4>
                 <img src={require('./../../assets/img/edu/3.png')} alt=""/>
               </div>
               <div className="item">
                 <h4>{t("loginEDU.t7")}</h4>
                 <img src={require('./../../assets/img/edu/4.png')} alt=""/>
               </div>

               <p>{t("loginEDU.t8")}</p>
             </div>

             {/*<div className="col-12 col-md-6">*/}
             {/*  <p>{t("about.t4")}:</p>*/}
             {/*  <a href="https://t.me/postex" target="_blank">https://t.me/postex</a>*/}
             {/*</div>*/}
             {/*<div className="col-12 col-md-6">*/}
             {/*  <p>{t("about.t5")}:</p>*/}
             {/*  <a href="https://instagram.com/postex.ir" target="_blank">https://instagram.com/postex.ir</a>*/}
             {/*</div>*/}
             {/*<div className="col-12 col-md-6">*/}
             {/*  <p>{t("about.t6")}:</p>*/}
             {/*  <a href="https://www.postex.ir">www.postex.ir</a>*/}
             {/*</div>*/}
             {/*<div className="col-12 col-md-6">*/}
             {/*  <p>{t("about.t7")}:</p>*/}
             {/*  <a href="tel:02191300250">02191300250</a>*/}
             {/*</div>*/}

             <div className="col-12">
               <div className="_btnGroup_yellow">
                 <Link to={{pathname: '/singleOrder', search: location?.search}} type="button" className="btnFill" id="singleOrder">
                   <span>{t("about.t9")}</span>
                   <Add/>
                 </Link>
               </div>
             </div>

           </div>
         </div>
       </div>
     </>
  )
}
